<template>
  <a-input
    :placeholder="placeholder"
    class="search"
    v-model="sCenter"
    @change="inputChange"
    @pressEnter="pressEnter"
  >
    <div slot="suffix" @pressEnter="pressEnter">
      <img
        src="@/assets/imgs/search.png"
        alt=""
        class="sImg"
        @click="imgSearch"
      />
    </div>
  </a-input>
</template>

<script>
/*

@params {
  
      <search @search="search" placeholder="请输入与考试相关的信息"></search>

      placeholder静态传递参数
      
      新增输入空值检测，提示错误信息
      
}
 

*/
export default {
  props: {
    placeholder: {
      type: String,
      default: "请输入搜索内容",
    },
  },
  data() {
    return {
      sCenter: "",
    };
  },
  methods: {
    inputChange() {
      if(this.sCenter == '') {
        this.$emit("search", this.sCenter);
      }
    },
    Fn() {
      this.$emit("search", this.sCenter);
    },
    imgSearch() {
      //点击图片进行搜索
      //  this.debounce(this.Fn, 500);
      // if (this.sCenter == "") return this.$message.error("输入不可为空");

      this.$emit("search", this.sCenter);

    },
    pressEnter() {
      // this.debounce(this.Fn, 500);
      // if (this.sCenter == "") return this.$message.error("输入不可为空");
      this.$emit("search", this.sCenter);
    },
    // 防抖
    // debounce(func, time) {
    //   let timer = null;
    //   return function () {
    //     clearTimeout(timer);
    //     timer = setTimeout(() => {
    //       func.apply(this, arguments);
    //     }, time);
    //   };
    // },
  },
  computed: {
    fontLength() {
      return this.sCenter.length;
    },
  },
  watch: {
    sCenter(newval) {
      if (newval.length > 20) {
        this.sCenter = "";
        this.$message.error("当前输入内容无效，请重新输入");
      }
    },
    fontLength(newval) {
      if (newval == '0') {
      this.$emit('zero')
      } 
    },
  },
};
</script>

<style lang="less" scoped>
.search {
  width: 100%;
  /deep/ .ant-input {
    border-radius: 20px;
    width: 98%;
    border: 1px solid #848684;
  }
  /deep/ .ant-input:hover {
    border-color: #2eadb5 !important;
  }
  /deep/ .sImg {
    width: 16px;
    height: 16px;
    cursor: pointer;
    margin-right: 4px;
  }

  // /deep/ .ant-input-affix-wrapper:hover {
  //   border-color: #2eadb5 !important;
  // }
  // /deep/.ant-input-suffix {
  //   top: 55%;
  // }
}
</style>